<template>
  <b-row>
    <b-col>
      <b-card title="Unit amenities">
        <blueprint-data api-route-path="inventory/amenities" :fields="fields">
          <template v-slot:default="{ state, item }">
            <b-form-group label="Name" label-for="name">
              <b-form-input id="name" v-model="item.name" :state="state('name')" type="text" placeholder="Name" />
            </b-form-group>
          </template>
        </blueprint-data>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>

export default {
  data () {
    return {
      fields: [
        {
          key: 'name',
          sortable: true,
        },
      ],
    };
  },
};
</script>
